import permission from "@/middlewares/permission";


function loadView( view, directory = null ) {
    
    if ( directory )
        return () => import(`@/views/admin/questions/${ directory }/${ view }.vue`);
    
    return () => import(`@/views/admin/questions/${ view }.vue`);
}


const Index = loadView( 'Index' );
const View = loadView( 'View' );
const Create = loadView( 'Create' );
const Edit = loadView( 'Edit' );

const HistoryView = loadView( 'View', 'History' );


const questionRoutes = [
    {
        path: 'questions',
        name: 'api.question.getList',
        component: Index,
        meta: {
            middleware: permission
        },
    },
    {
        path: 'questions/create',
        name: 'api.question.create',
        component: Create,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'questions/:id',
        name: 'api.question.get',
        component: View,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'questions/:id/edit',
        name: 'api.question.update',
        component: Edit,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'question-history/:id',
        name: 'api.question.history.get',
        component: HistoryView,
        meta: {
            middleware: permission
        }
    }
];

export default questionRoutes;
